// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3ge6A","search":"Settings_search__1wJ6A","filter":"Settings_filter__1dMCB"};